'use strict';
import * as $i_d3 from "d3";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_d3$() {
}
export { $c_Lpresto_d3$ as $c_Lpresto_d3$ };
$p = $c_Lpresto_d3$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_d3$;
/** @constructor */
function $h_Lpresto_d3$() {
}
export { $h_Lpresto_d3$ as $h_Lpresto_d3$ };
$h_Lpresto_d3$.prototype = $p;
$p.cPR = (function(node) {
  return $i_d3.select(node);
});
$p.cKy = (function(data) {
  return $i_d3.hierarchy(data);
});
$p.cNY = (function() {
  return $i_d3.partition();
});
$p.cBC = (function() {
  return $i_d3.arc();
});
$p.cPL = (function(range) {
  return $i_d3.scaleOrdinal(range);
});
$p.cOp = (function(interpolator, n) {
  return $i_d3.quantize(interpolator, n);
});
$p.cKV = (function() {
  return $i_d3.interpolateRainbow;
});
$p.cKU = (function(a, b) {
  return $i_d3.interpolate(a, b);
});
var $d_Lpresto_d3$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_d3$, "presto.d3$", ({
  VC: 1
}));
export { $d_Lpresto_d3$ as $d_Lpresto_d3$ };
var $n_Lpresto_d3$;
function $m_Lpresto_d3$() {
  if ((!$n_Lpresto_d3$)) {
    $n_Lpresto_d3$ = new $c_Lpresto_d3$();
  }
  return $n_Lpresto_d3$;
}
export { $m_Lpresto_d3$ as $m_Lpresto_d3$ };
//# sourceMappingURL=presto.d3$.js.map
